export const userTrackingIDs = {
    periodicControl: {
        id: 'dagligbank-periodic-control',
        updateId: 'dagligbank-update-periodic-control',
    },
    contactInfo: {
        id: 'dagligbank-update-customer-information',
        updateId: 'dagligbank-update-contact-information',
    },
    birthdayConfetti: {
        id: 'dagligbank-birthday-confetti',
    },
};
